export const BRANDING_ASSET_KINDS = {
  LOGO: "logo",
  LOGO_DARK: "logo_dark",
  FAVICON: "favicon",
  EMAIL_LOGO: "email_logo",
};

// Mirrored by validation.schema.js (the enforced limit) and BrandingForm.jsx
// (the live character counter) so the number is written once.
export const BRANDING_DISPLAY_NAME_MAX_LENGTH = 150;

export const BRANDING_FORM_DEFAULTS = {
  displayName: "",
  // Color configuration is disabled (see BrandingForm.jsx / BrandingProvider.jsx).
  // primaryColor: "",
  // primaryColorContrast: "",
  // primaryColorDark: "",
  // primaryColorContrastDark: "",
  expectedUpdatedAt: null,
};

// Fallback colors used when a tenant has no saved branding config yet, so a
// first-time save isn't blocked by empty color fields (colors are required
// for publish — see BrandingConfig on the backend).
// Disabled along with the rest of the color configuration feature.
// export const BRANDING_COLOR_DEFAULTS = {
//   primaryColor: "#0055FF",
//   primaryColorContrast: "#FFFFFF",
//   primaryColorDark: "#3F87FF",
//   primaryColorContrastDark: "#000000",
// };

export const BRANDING_ASSET_META = {
  [BRANDING_ASSET_KINDS.LOGO]: {
    label: "Logo",
    helperText: "Used on light backgrounds. Falls back to Dark Logo if not uploaded.",
  },
  [BRANDING_ASSET_KINDS.LOGO_DARK]: {
    label: "Dark Logo",
    helperText: "Used on dark backgrounds. Falls back to Logo if not uploaded.",
  },
  [BRANDING_ASSET_KINDS.FAVICON]: {
    label: "Favicon",
    helperText: "Used in the browser tab.",
  },
  [BRANDING_ASSET_KINDS.EMAIL_LOGO]: {
    label: "Email Logo",
    helperText: "Used in branded emails.",
  },
};

// export const BRANDING_COLOR_FIELDS = [
//   "primaryColor",
//   "primaryColorContrast",
//   "primaryColorDark",
//   "primaryColorContrastDark",
// ];
